module.exports = __webpack_public_path__ + "img/title-3.52289fd9.png";